export class User{
    ID :string;
    Username :string;
    Password :string;
    Email :String;

    constructor()
    {
        this.ID = "";
        this.Username = "";
        this.Password = "";
        this.Email = "";
    }
}